import { render, staticRenderFns } from "./role_gl.vue?vue&type=template&id=7e50a38f&scoped=true&"
import script from "./role_gl.vue?vue&type=script&lang=js&"
export * from "./role_gl.vue?vue&type=script&lang=js&"
import style0 from "./role_gl.vue?vue&type=style&index=0&id=7e50a38f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e50a38f",
  null
  
)

export default component.exports